"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
import {
  Component,
  PropSync
} from "vue-property-decorator";
import UiForm from "@/components/form/UiForm.vue";
import UiSubmit from "@/components/form/UiSubmit.vue";
import _ from "lodash";
import { ControllerComponent } from "@/components/core";
import { Debounce } from "vue-debounce-decorator";
let HeaderSearch = class extends ControllerComponent {
  get $query() {
    return this._query;
  }
  searchChange() {
    const _keyword = _.get(this.$query, "keyword");
    this.$query.clear();
    _.set(this.$query, "name", null);
    _.set(this.$query, "keyword", _keyword);
    this.$emit("search", this.$query);
  }
};
__decorateClass([
  PropSync("query")
], HeaderSearch.prototype, "_query", 2);
__decorateClass([
  Debounce(800)
], HeaderSearch.prototype, "searchChange", 1);
HeaderSearch = __decorateClass([
  Component({
    components: {
      UiForm,
      UiSubmit
    }
  })
], HeaderSearch);
export {
  HeaderSearch as default
};
